var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailcreate2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1330_3955",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1330_3955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.25651C8.73802 9.25651 8.08575 8.98523 7.5432 8.44268C7.00051 7.89999 6.72917 7.24766 6.72917 6.48568C6.72917 5.7237 7.00051 5.07143 7.5432 4.52888C8.08575 3.98619 8.73802 3.71484 9.5 3.71484C10.262 3.71484 10.9142 3.98619 11.4568 4.52888C11.9995 5.07143 12.2708 5.7237 12.2708 6.48568C12.2708 7.24766 11.9995 7.89999 11.4568 8.44268C10.9142 8.98523 10.262 9.25651 9.5 9.25651ZM3.5625 15.2854V13.5254C3.5625 13.1377 3.66779 12.7787 3.87838 12.4483C4.08896 12.1179 4.3704 11.8639 4.72269 11.6863C5.50512 11.3028 6.29448 11.0151 7.09076 10.8232C7.88705 10.6314 8.69012 10.5354 9.5 10.5354C10.3099 10.5354 11.113 10.6314 11.9092 10.8232C12.7055 11.0151 13.4949 11.3028 14.2773 11.6863C14.6296 11.8639 14.911 12.1179 15.1216 12.4483C15.3322 12.7787 15.4375 13.1377 15.4375 13.5254V15.2854H3.5625ZM4.75 14.0979H14.25V13.5254C14.25 13.3651 14.2036 13.2166 14.1107 13.0801C14.0178 12.9436 13.8917 12.8323 13.7324 12.746C13.0503 12.41 12.3548 12.1555 11.646 11.9824C10.9371 11.8094 10.2217 11.7229 9.5 11.7229C8.77826 11.7229 8.06293 11.8094 7.35399 11.9824C6.64518 12.1555 5.9497 12.41 5.26755 12.746C5.1083 12.8323 4.98222 12.9436 4.88933 13.0801C4.79644 13.2166 4.75 13.3651 4.75 13.5254V14.0979ZM9.5 8.06901C9.93542 8.06901 10.3082 7.91398 10.6182 7.60391C10.9283 7.29384 11.0833 6.92109 11.0833 6.48568C11.0833 6.05026 10.9283 5.67752 10.6182 5.36745C10.3082 5.05738 9.93542 4.90234 9.5 4.90234C9.06458 4.90234 8.69184 5.05738 8.38177 5.36745C8.0717 5.67752 7.91667 6.05026 7.91667 6.48568C7.91667 6.92109 8.0717 7.29384 8.38177 7.60391C8.69184 7.91398 9.06458 8.06901 9.5 8.06901Z",
    fill: "#001E40",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailcreate2);
export default __webpack_public_path__ + "static/media/mailcreate (2).4f60afc1b720ed820650c2f143896efa.svg";
export { ForwardRef as ReactComponent };